export default "__VITE_ASSET__Ds0tZJf5__"